import { NotificationIdentifierModel } from './notification-identifier.model';
import { ConfigConstants } from '../../config/config-constants';
import { ODataObject } from '../../interfaces/odata-model.interface';
import moment from 'moment';

export class NotificationHistoryModel {
    public readonly identifier: NotificationIdentifierModel;
    public readonly functionalLoc: string;
    public readonly notificationNumber: string;
    public readonly taskNumber: string;
    public readonly notificationType: ConfigConstants.NotificationTypes;
    public readonly languageId: string;
    public readonly name1: string;
    public readonly name2: string;
    public readonly name3: string;
    public readonly name4: string;
    public readonly materialNo: string;
    public readonly serialNo: string;
    public readonly equipmentNumber: string;
    public readonly description: string;
    public readonly endDate: moment.Moment;
    public readonly docBoxId: string;
    public readonly fileName: string;

    public constructor(notification: ODataNotificationHistoryModel) {
        this.functionalLoc = notification.FuncLoc;
        this.identifier = new NotificationIdentifierModel(
            notification.FrontId,
            notification.NotificationNo,
            notification.TaskNumber,
        );
        this.notificationNumber = notification.NotificationNo;
        this.taskNumber = notification.TaskNumber;

        this.name1 = notification.Name1;
        this.name2 = notification.Name2;
        this.name3 = notification.Name3;
        this.name4 = notification.Name4;
        this.materialNo = notification.Material;
        this.serialNo = notification.SerialNo;
        this.equipmentNumber = notification.EquipmentNumber;
        this.description = notification.Description;
        this.endDate = moment(notification.EndDate);
        this.docBoxId = notification.DocBoxId;
        this.fileName = notification.FileName;
    }

    public get completeName(): string {
        return this.name1.trim() + ' ' + this.name2.trim() + ' ' + this.name3.trim() + ' ' + this.name4.trim();
    }
}

export interface ODataNotificationHistoryModel extends ODataObject {
    __metadata: {
        id: string;
        uri: string;
        type: 'HC_SM_NGM_58_SRV.NotificationHistory';
    };
    Title: string;
    FileName: string;
    DocType: string;
    ContentType: string;
    SourceSystem: string;
    Customer: string;
    Material: string;
    SerialNo: string;
    FuncLoc: string;
    ProtectionClass: string;
    StorageLocation: string;
    DocBoxId: string;
    StartDate: string;
    EndDate: string;
    CustomerName: string;
    CreatedBy: string;
    Language: string;
    OrderNumber: string;
    PrintNumber: string;
    Description: string;
    CauseCode: string;
    NotificationNo: string;
    NotificationType: ConfigConstants.NotificationTypes;
    ContractNo: string;
    EquipmentNumber: string;
    ReportStatus: string;
    Country: string;
    SalesOrg: string;
    Plant: string;
    NumberOfDays: string;
    FileType: string;
    TaskNumber: string;
    FrontId: string;
    ActivityNo: string;
    Name1: string;
    Name2: string;
    Name3: string;
    Name4: string;
    Name1Long: string;
    Name2Long: string;
    Name3Long: string;
    Name4Long: string;
    UserStatus: ConfigConstants.USER_STATUS;
    TaskGroup: string;
    LanguageId: string;
    LanguageText: string;
}
